import React from "react"
import { Chart, ChartOptions } from "chart.js"
const colors = [[100, 181, 246], [174, 213, 129], [114, 114, 114]]
const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

export interface IProps {
    data1
    data2?
    label1
    label2?
}
export default class TrendCompareGraph extends React.Component<IProps, any> {
    download_chart
    componentDidMount() {
        this.loadChart()
    }

    componentDidUpdate() {
        this.loadChart()
    }

    groupDates(downloads) {
        const groupedDates = []
        for (let i = 11; i >= 0; i--) {
            const currentDate = new Date()
            currentDate.setMonth(currentDate.getMonth() - i)
            groupedDates.push({
                period: monthNames[currentDate.getMonth()],
                downloads: downloads[11 - i]
            })
        }

        return groupedDates
    }

    loadChart() {
        if (typeof this.download_chart !== "undefined") {
            this.download_chart.destroy()
        }
        let i = 0
        let dataColor = colors[i].join(",")
        const labelColor = colors[2].join(",")

        const chart_data = { labels: [], datasets: [] }
        if (this.props.data1 && this.props.data1.length > 0) {
            i++
            const groupedData = this.groupDates(this.props.data1)
            chart_data.labels = groupedData.map((download) => download.period)

            const data = groupedData.map((download) => download.downloads)
            const dataset = {
                label: this.props.label1,
                backgroundColor: "rgba(" + dataColor + ",0.1)",
                borderColor: "rgba(" + dataColor + ",1)",
                pointBackgroundColor: "rgba(" + dataColor + ",1)",
                pointBorderColor: "#64B5F6",
                pointBorderWidth: 0,
                data,
                yAxisID: this.props.label1.toLowerCase()
            }
            chart_data.datasets.push(dataset)
        }

        const axis1 = {
            id: this.props.label1.toLowerCase(),
            position: "left",
            ticks: {
                min: 0,
                maxTicksLimit: 7,
                fontColor: "rgba(" + labelColor + ",1)"
            },
            gridLines: {
                display: false
            }
        }

        if (this.props.data2 && this.props.data2.length > 0) {
            dataColor = colors[i].join(",")
            const groupedData = this.groupDates(this.props.data2)
            if (this.props.data1 <= 0) {
                const labels = groupedData.map((download) => download.period)
                chart_data.labels = labels
            }
            const data = groupedData.map((download) => download.downloads)
            const dataset = {
                label: this.props.label2,
                backgroundColor: "rgba(" + dataColor + ",0.1)",
                borderColor: "rgba(" + dataColor + ",1)",
                pointBackgroundColor: "rgba(" + dataColor + ",1)",
                pointBorderColor: "#AED581",
                data,
                yAxisID: this.props.label2.toLowerCase()
            }
            chart_data.datasets.push(dataset)
        }

        const axis2 = this.props.label2 &&
        {
            id: this.props.label2.toLowerCase(),
            position: "right",
            ticks: {
                min: 0,
                maxTicksLimit: 7,
                fontColor: "rgba(" + labelColor + ",1)"
            },
            gridLines: {
                display: false
            }
        }

        if ((this.props.data1 && this.props.data1.length > 0) || (this.props.data2 && this.props.data2.length > 0)) {
            const chart_options: ChartOptions = {
                responsive: true,
                scales: {
                    scaleLabel: {
                        fontColor: "#000000",
                        labelString: "<%= ' ' + value%>"
                    },
                    yAxes: this.props.label2 ? [axis1, axis2] : [axis1],
                    xAxes: [
                        {
                            gridLines: {
                                display: false
                            }
                        }
                    ]
                },
                legend: {
                    display: !!this.props.label2
                }
            }
            const ctx: HTMLCanvasElement = document.getElementById("download_chart") as HTMLCanvasElement
            ctx.getContext("2d")
            this.download_chart = new Chart(ctx, {
                data: chart_data,
                options: chart_options,
                type: "line"
            })
        }
    }

    render() {
        return (
            <div className="TrendCompareGraph">
                {((this.props.data1 && this.props.data1.length > 0) || (this.props.data2 && this.props.data2.length > 0)) &&
                    <canvas id="download_chart" />
                }
            </div>
        )
    }
}
